import Image from 'next/image';
import GridSection from './GridSection/car-grid.component';
import ModalInfo from './InfoModal/modal-info.component';
import CarInfo from './CarInfoSection/car-info.component';
import PropositionBanners from './proposition-banners.component';
import NotifyMeButton from './NotifyMe/Button/notify-me-button.component';

import {
  ElectricalFaulty,
  ElectricalGood,
  ExteriorFaulty,
  ExteriorGood,
  InteriorFaulty,
  InteriorGood,
  MechanicalFaulty,
  MechanicalGood,
  SuspensionFaulty,
  SuspensionGood,
  TyreFaulty,
  TyreGood,
} from '../../../../public/Images';

export const imperfectionReportIcons = {
  Exterior: {
    good: <Image src={ExteriorGood} alt="ExteriorGood" />,
    faulty: <Image src={ExteriorFaulty} alt="ExteriorFaulty" />,
  },
  Electricals: {
    good: <Image src={ElectricalGood} alt="ElectricalGood" />,
    faulty: <Image src={ElectricalFaulty} alt="ElectricalFaulty" />,
  },
  Interior: {
    good: <Image src={InteriorGood} alt="InteriorGood" />,
    faulty: <Image src={InteriorFaulty} alt="InteriorFaulty" />,
  },
  Suspension: {
    good: <Image src={SuspensionGood} alt="SuspensionGood" />,
    faulty: <Image src={SuspensionFaulty} alt="SuspensionFaulty" />,
  },
  Tyres: {
    good: <Image src={TyreGood} alt="TyreGood" />,
    faulty: <Image src={TyreFaulty} alt="TyreFaulty" />,
  },
  Mechanical: {
    good: <Image src={MechanicalGood} alt="MechanicalGood" />,
    faulty: <Image src={MechanicalFaulty} alt="MechanicalFaulty" />,
  },
};
export const getImperfectionReportIcon = (value: string) => {
  try {
    const divided = value.split('-');
    const bodyType = imperfectionReportIcons[divided[0] as keyof typeof imperfectionReportIcons];
    if (divided[1]) {
      if (divided[1] == 'good') {
        return bodyType.good;
      } else {
        return bodyType.faulty;
      }
    }
  } catch (error) {
    return null;
  }
};

export { GridSection, ModalInfo, CarInfo, PropositionBanners, NotifyMeButton };
